import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium tabular-nums",
  {
    variants: {
      variant: {
        default: "bg-surface-1 text-ink-700 border border-line",
        count: "bg-p-600 text-white",
        soft: "bg-vroom-red-soft text-vroom-red border border-vroom-red-edge",
        role: "bg-p-50 text-p-700 font-mono uppercase tracking-[.08em] text-[9.5px] px-2 py-0.5",
        "status-todo": "text-st-todo-fg",
        "status-ok": "text-st-ok-fg",
        "status-rej": "text-st-rej-fg",
        "status-exp": "text-st-exp-fg",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
